import {makeObservable, observable} from 'mobx'
import BaseModel from './BaseModel'

export default class GameMembersQuery extends BaseModel{
  constructor(store) {
    super(store);
    makeObservable(this, {
      title: observable,
      year_born: observable
    })
  }
  
  title = '';
  year_born = '';
}